<!--
 * @Description: 
 * @Date: 2022-05-24 10:57:37
-->
<template>
  <el-dialog
    width="600px"
    title="创建活动"
    :visible="true"
    :close-on-press-escape="false"
    :before-close="() => $emit('remove')"
  >
    <el-form
      ref="form"
      :model="formInline"
      label-position="right"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item label="活动名称" prop="activityName" ref="activityName">
        <el-input
          v-model="formInline.activityName"
          placeholder="最多输入50个字"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('remove')">取 消</el-button>
      <el-button type="primary" @click="confirm" :loading="loading">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { activity } from '@/api/ajax';

export default {
  name: 'active-add',
  data: () => ({
    rules: {
      activityName: [{ required: true, message: '活动名称不能为空' }]
    },
    formInline: {
      activityName: ''
    },
    loading: false
  }),
  methods: {
    async confirm() {
      // 本地验证表单内容
      await this.$refs.form.validate();
      try {
        // 远程校验 调用接口
        const { id } = this.$store.state.homeProject;
        this.loading = true;
        await activity.add({
          projectId: id,
          activityName: this.formInline.activityName
        });
        // success!!!
        this.$message.success('新增成功');
        this.$emit('confirm');
        this.$emit('remove');
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
/deep/ .el-input__inner {
  padding: 5px 50px 5px 15px !important;
}
</style>
